module.exports = __webpack_public_path__ + "img/appleStore.cc126d73.png";